/**
 * HTTP client for the cross-source "Asuntos sin atender" inbox.
 * Live path: authenticated `GET /api/unattended-inbox` (Functions or local BFF).
 */

import type { UnattendedInboxResponse } from '@zunelo/shared';
import type { ApiEnvelope } from '../../domain/types';
import type { HttpClientOptions, IUnattendedInboxClient } from './types';
import { createHttpTransport, type HttpTransport } from './httpTransport';
import { parseEnvelope } from './parseEnvelope';

export class HttpUnattendedInboxClient implements IUnattendedInboxClient {
  private readonly transport: HttpTransport;

  constructor(options: HttpClientOptions | string = {}) {
    this.transport = createHttpTransport(options);
  }

  async getUnattendedInbox(options?: { fresh?: boolean }): Promise<ApiEnvelope<UnattendedInboxResponse>> {
    const freshParam = options?.fresh === true ? '?fresh=1' : '';
    const response = await this.transport.fetch(`/api/unattended-inbox${freshParam}`);

    return parseEnvelope<UnattendedInboxResponse>(response, undefined, 'UNATTENDED_INBOX_HTTP_ERROR');
  }
}